import {Injectable, OnInit} from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {HttpClient, HttpHeaders, HttpClientModule} from "@angular/common/http"
import {environment} from "../../../environments/environment";

import {Observable} from "rxjs";
import {Command} from "./command";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "../security/auth.service";


/*
 public $key: string,
 public club: string,
 public field: string,
 public cpu: string,
 public psu:number,
 public request: string,
 public soll: number,
 public reply: string,
 public ist: number,
 public status: string,
 public simulate: boolean,
 public retries: number
 */

@Injectable()
export class CommandService implements OnInit {

  constructor(private db: AngularFireDatabase, private http: HttpClient, private translate: TranslateService, private authService: AuthService) {
  }

  ngOnInit() {
    //console.log('In Commandservice!');
  }

  addCommand(clubId: string, fieldId: string, cpuId: string, psu: number, request: string, soll: number, simulate: boolean, usesField: string, user: string, type?: string) {

    let newCmd = {
      "club": clubId,
      "field": fieldId,
      "cpu": cpuId,
      "psu": psu,
      "request": request,
      "soll": parseInt(soll.toString()),
      "user": user,
      "type": type,
      "appVersion": environment.appVersion
    };
    //console.log( newCmd );

    if ( type === null || type === undefined ) {
      if ( psu === null && ( cpuId === "" || cpuId === null ) ) {
        newCmd.type = 'field';
      } else if ( ( cpuId !== "" && cpuId !== null ) && psu === null ) {
          newCmd.type = 'cpu';
      } else if ( ( cpuId !== "" && cpuId !== null ) && psu !== null ) {
        newCmd.type = 'psu';
      }
    }

    this.sendCommand( newCmd );
  }

  sendCommand( payload: any ) {
    let url = "";
    let tokenUrl = "";
    //console.log(`in production environment: ${environment.production}`);
    if ( environment.production ) {
      tokenUrl = "https://st-api-prod.appspot.com/refresh_token";
      url = "https://st-api-prod.appspot.com/api";
    } else {
      tokenUrl = "https://platinum-scout-219913.appspot.com/refresh_token";
      url = "https://platinum-scout-219913.appspot.com/api";
    }

    //console.log(newCmd);
    let refreshToken = this.authService.getRefreshToken();
    //console.log(refreshToken);

    if ( refreshToken === "" ) {
      this.translate.get('e.token').subscribe(res => {
        console.log(res);
        alert(res);
      });
    } else {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin':'*'
        })
      };

      let tokenBody = {
        refreshToken: refreshToken
      };
      //console.log('token body:');
      //console.log(tokenBody);

      this.http.post(tokenUrl, tokenBody, httpOptions).subscribe( loginToken => {
        //var token = <object>loginToken;

        if ( loginToken.hasOwnProperty('refreshToken')) {
          //console.log('valid login token found');
          httpOptions.headers = httpOptions.headers.set('Authorization', `Bearer ${loginToken['loginToken']}`);
        }

        //console.log( payload );

        this.http.post(url, payload, httpOptions).subscribe( reply => {
          let r: any = reply;
          //console.log(`type of reply: ${typeof reply}`);
          if ( r !== null ) {
            //console.log(JSON.stringify(r));
            if ( r.hasOwnProperty('error') ) {
              this.translate.get(r.error).subscribe(res => {
                let msg = `${res} ${r.user} (max. ${r.wait}s)`;
                alert(msg);
              });
            }
            if ( r.hasOwnProperty('reply') && r.reply.status === "ERROR" ) {
              this.translate.get(r.reply.error).subscribe(res => {
                let msg = `${res}`;
                alert(msg);
              });
            }
          }
        }, error => {
          //console.log ( `error: ${JSON.stringify(error['error'])}` );
          this.translate.get(error.error.error).subscribe(res => {
            //console.log(msg);
            alert( res );
          });
        });
      });
    }
  }

}
